import { Link } from 'react-router-dom';
import { Card, bySlotOrder, slotLabel } from '../components/ui';
import { DishCard } from '../components/DishCard';
import type { DashboardModuleProps } from './registry';

const T = {
  en: {
    today: 'Today',
    tomorrow: 'Tomorrow',
    nothing: 'No meals planned for today.',
    plan: 'Plan the week',
    lunch: 'Lunch',
    dinner: 'Dinner',
  },
  fr: {
    today: "Aujourd'hui",
    tomorrow: 'Demain',
    nothing: "Rien de prévu aujourd'hui.",
    plan: 'Planifier la semaine',
    lunch: 'Déjeuner',
    dinner: 'Dîner',
  },
} as const;

/**
 * The first thing anyone sees on the kitchen tablet (§4, §54):
 * today's meals, who is eating, and a prominent way into the cooking page.
 */
export function TodayModule({ today, week, language, refresh }: DashboardModuleProps) {
  const t = T[language];
  const slots = today?.today?.slots ?? [];
  const hasMeals = slots.some((slot) => slot.dishes.some((dish) => dish.meal));

  const tomorrowNames = (today?.tomorrow?.slots ?? [])
    .flatMap((slot) => slot.dishes)
    .map((dish) => dish.meal?.name)
    .filter(Boolean) as string[];

  return (
    <Card
      title={
        <div>
          <h2>{t.today}</h2>
          <p className="dim">{today?.dateLabel}</p>
        </div>
      }
      tight
    >
      {!hasMeals ? (
        <div className="empty">
          <p style={{ marginBottom: 14 }}>{t.nothing}</p>
          {/* Planning happens on the Plan page. Today is for what is already
              decided, so this points at the job rather than doing it here. */}
          <Link className="btn primary" to="/plan">
            {t.plan}
          </Link>
        </div>
      ) : (
        <div style={{ margin: '0 -18px' }}>
          {[...slots].sort(bySlotOrder).map((slot) =>
            slot.dishes.map((dish, index) => (
              <div key={dish.assignmentKey}>
                {index === 0 && (
                  <div className="audience-tag" style={{ padding: '10px 18px 0' }}>
                    {slotLabel(slot.slotType, language)}
                  </div>
                )}
                <DishCard
                  dish={dish}
                  language={language}
                  showAudience={slot.dishes.length > 1}
                  onFavourite={() => refresh()}
                />
              </div>
            )),
          )}
        </div>
      )}

      {tomorrowNames.length > 0 && (
        <p className="dim" style={{ paddingTop: 12, borderTop: '1px solid var(--line)', marginTop: 4 }}>
          <strong>{t.tomorrow}:</strong> {tomorrowNames.join(' · ')}
        </p>
      )}
    </Card>
  );
}
